import React from 'react';
import { History } from 'history';
import { Input, InputMultiline, InputDate, InputNumber, InputMoney, InputSelect, InputPicklist } from '../../components';
import BaseCreate from '../base/base-create.component'; 
import BaseView from '../base/base-view.component';
import Model from './journal-model';  //editable..
import TransactionModel from '../transaction/transaction-model';
import CoaPicklist from '../coa/coa-picklist.component';

interface IProps { 
    history: History;
}

interface IState {
    datarow: Model;
    errors: any;
}

export default class JournalCreate extends  React.Component<IProps, IState> {
    constructor(props:IProps) {
        super(props);  
        this.state = {
            datarow: Model.defaultValue(),
            errors: null,
        }
        this.onChange = this.onChange.bind(this);
    }
    
    private historyState: any = this.props.history.location.state;
    
    private onLoadTransaction = (data: any) => {
        this.setState({ datarow: { ...this.state.datarow, 'transaction': data?.id, 'transactionCaption': data?.name || ''  }  });
    }
    
    private onLoadCoa = (data: any) => {
        this.setState({ datarow: { ...this.state.datarow, 'coa': data?.id, 'coaCaption': data?.name || ''  }  });
    }
    
    private onError = (data: any) => {
        this.setState({errors: data});
    }
    
    private onChange(fieldName: string, value?: string) { 
        const nextState = {
            ...this.state, datarow: {
                ...this.state.datarow, [fieldName]: value,
            }
        }
        this.setState(nextState);
    }

    public componentDidMount(): void {        
        this.onLoadTransaction({'id': this.historyState?.id});
    }

    render() {
        return (
            //editable..    
            <>
            {this.historyState?.id > 0 &&
            <BaseView history={this.props.history} caption=''
                model={TransactionModel} onLoad={this.onLoadTransaction}/>
            }
            <BaseCreate history={this.props.history} 
                model={Model} datarow={this.state.datarow} onError={this.onError}>               
                
                <Input name='name' label='Name' value={this.state.datarow.name} error={this.state.errors?.name} onChange={this.onChange} />
                <InputMultiline name='description' label='Description' value={this.state.datarow.description} error={this.state.errors?.description} onChange={this.onChange} />
                <InputSelect name='status' label='status' value={this.state.datarow.status} options={Model.optionStatus} error={this.state.errors?.status} onChange={this.onChange} />
                <InputDate name='journaldate' label='Date' value={this.state.datarow.journaldate} error={this.state.errors?.journaldate} onChange={this.onChange} />
                <InputNumber name='seq' label='Sequence' value={this.state.datarow.seq} error={this.state.errors?.seq} onChange={this.onChange} />
                <InputSelect name='sign' label='Debet/Credit' value={this.state.datarow.sign} options={Model.optionSign} error={this.state.errors?.sign} onChange={this.onChange} />
                <InputMoney name='value' label='Value' value={this.state.datarow.value} error={this.state.errors?.value} onChange={this.onChange} />
                <InputPicklist name='coa' label='COA' value={this.state.datarow.coa} caption={this.state.datarow.coaCaption} error={this.state.errors?.coa} onChange={this.onChange} >
                    <CoaPicklist currentId={this.state.datarow.coa} onLoad={this.onLoadCoa}/>
                </InputPicklist>
            </BaseCreate>
            </>
        );
    }     
     
}